import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { waLink } from "../lib/wa";
import { useAuth } from "../auth";
import { useNavigate } from "react-router-dom";
import OxyHeader from "../components/OxyHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card } from "@/components/ui/card";
import { MessageCircle, Plus } from "lucide-react";
import { toast } from "sonner";

export default function Support() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [form, setForm] = useState({ subject: "", message: "" });
  const [oxy, setOxy] = useState(null);

  useEffect(() => {
    if (!user) { navigate("/"); return; }
    api.get("/support/tickets").then(r => setTickets(r.data));
    api.get("/oxy/settings").then(r => setOxy(r.data));
  }, [user]);

  const submit = async () => {
    if (!form.subject || !form.message) return toast.error("Fill in both fields");
    await api.post("/support/ticket", form);
    setForm({ subject: "", message: "" });
    api.get("/support/tickets").then(r => setTickets(r.data));
    toast.success("Ticket submitted");
  };

  const wa = () => window.open(waLink(oxy?.whatsapp_number, "I need help with OxyCom"), "_blank");

  if (!user) return null;

  return (
    <div className="min-h-screen bg-slate-50">
      <OxyHeader/>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="text-3xl font-extrabold mb-6">Support Center</h1>

        <Card className="p-6 mb-6 bg-gradient-to-br from-emerald-500 to-teal-600 text-white">
          <h3 className="font-bold text-lg flex items-center gap-2"><MessageCircle className="w-5 h-5"/>WhatsApp Support</h3>
          <p className="text-emerald-50 text-sm mt-1 font-bn">দ্রুত সাহায্যের জন্য WhatsApp এ চ্যাট করুন</p>
          <Button onClick={wa} className="mt-4 bg-white text-emerald-700 hover:bg-emerald-50 rounded-full" data-testid="wa-btn">Chat: {oxy?.whatsapp_number}</Button>
        </Card>

        <Card className="p-6 mb-6">
          <h3 className="font-bold mb-3 flex items-center gap-2"><Plus className="w-5 h-5"/>New Support Ticket</h3>
          <div className="space-y-3">
            <div><Label>Subject</Label><Input value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} data-testid="ticket-subject"/></div>
            <div><Label>Message</Label><Textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})} rows={4} data-testid="ticket-msg"/></div>
            <Button onClick={submit} className="bg-sky-500 hover:bg-sky-600" data-testid="ticket-submit">Submit Ticket</Button>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="font-bold mb-3">Your Tickets</h3>
          {tickets.length === 0 ? <div className="text-slate-400 text-sm">No tickets yet</div> : (
            <div className="space-y-2">
              {tickets.map(t => (
                <div key={t.ticket_id} className="p-3 rounded-lg bg-slate-50 border">
                  <div className="flex justify-between items-start">
                    <div className="font-semibold text-sm">{t.subject}</div>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${t.status === "open" ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"}`}>{t.status}</span>
                  </div>
                  <div className="text-xs text-slate-500 mt-1">{t.message}</div>
                </div>
              ))}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
